export default __webpack_public_path__ + "static/media/Q18_1_resized.82628b9a.jpg";